import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { UmssIconComponent } from "../icon/icon.component";

@Component({
  selector: "umss-loading-button",
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: "./loading-button.component.html",
  styleUrls: ["./loading-button.component.scss"],
})
export class UmssLoadingButtonComponent {
  @HostBinding("style.display") display = "contents";

  constructor() { }

  /** Content props - Clean and semantic */
  @Input() label: string = "Loading...";
  @Input() loadingText?: string; // Optional override for loading state text
  @Input() spinnerIcon?: string; // Optional custom Phosphor spinner icon (e.g., 'phosphorCircleNotch', 'phosphorSpinner')

  /** Variant props - Well-typed and comprehensive */
  @Input() variant: 'primary' | 'secondary' | 'destructive' | 'outline' | 'ghost' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  /** State props - Simple and clear */
  @Input() loading: boolean = true; // Default to loading state
  @Input() disabled: boolean = false;

  /** Events - Proper event handling */
  @Output() onClick = new EventEmitter<MouseEvent>();

  onButtonClick(event: MouseEvent) {
    if (!this.disabled && !this.loading) {
      this.onClick.emit(event);
    }
  }

  /** Computed properties */
  get displayText(): string {
    if (this.loading && this.loadingText) {
      return this.loadingText;
    }
    return this.loading ? 'Loading...' : this.label;
  }
  
  get spinnerIconName(): string {
    return this.spinnerIcon || 'phosphorCircleNotch'; // Default to CircleNotch spinner
  }
  
  get spinnerSize(): string {
    switch (this.size) {
      case 'small': return '14px';
      case 'medium': return '16px';
      case 'large': return '20px';
      default: return '16px';
    }
  }
}
